export const CommonBase = {
  MuiPickersBasePicker: {
    container: {
      "& h4": {
        fontSize: "2.125rem",
        lineHeight: 1.235,
      },
    },
  },
};
